import _ from 'lodash';
import ApiService from './apiService';

export async function uploadFile({ file, fileName, arrayBuffer, fileType }) {
  let bodyStream;
  if (file) {
    bodyStream = await file.arrayBuffer();
    fileType = file.type;
    fileName = file.name;
  } else {
    bodyStream = arrayBuffer;
  }
  if (!fileName || !fileType || !bodyStream) {
    throw new Error('Missing necessary params for uploading file');
  }
  const uploadUrlObj = await ApiService.getUploadUrlForFileName(fileName);
  const { uploadUrl, attachment } = uploadUrlObj;
  await ApiService.uploadFile(uploadUrl, fileType, bodyStream);
  return attachment;
}

export async function getFileURL({ key }) {
  const signedUrl = await ApiService.getDownloadUrlForS3Key(key);
  return signedUrl;
}

export async function uploadMultipleFiles({ files }) {
  const filesObj = [];
  const s3ObjectArr = [];
  for (const file of files) {
    const obj = { bodyStream: '', file: '', fileName: '', fileType: '' };
    if (file) {
      obj.bodyStream = await file.arrayBuffer();
      obj.fileType = file.type;
      obj.fileName = file.name;
    }
    if (!obj?.fileName || !obj?.fileType || !obj?.bodyStream) {
      throw new Error('Missing necessary params for uploading file');
    }
    filesObj.push(obj);
  }
  const uploadUrlObjs = await ApiService.getUploadUrlForFileName(filesObj.map((file) => file.fileName));
  const filesObjDict = _.keyBy(filesObj, 'fileName');
  const promises = uploadUrlObjs.map((urlObjs) => {
    const { uploadUrl = '', attachment } = urlObjs;
    s3ObjectArr.push(attachment);
    const reqFileObj = filesObjDict[attachment.fileName];
    return ApiService.uploadFile(uploadUrl, reqFileObj.fileType, reqFileObj.bodyStream);
  });
  const res = await Promise.allSettled(promises);
  const processed = [];
  const unprocessed = [];
  res.forEach((val, index) => {
    if (val.status === 'fulfilled') {
      processed.push(s3ObjectArr[index]);
    } else {
      unprocessed.push(s3ObjectArr[index]);
    }
  });
  console.log('res', res);
  return { processed, unprocessed };
}
